<div class="modal-cover" [ngClass]="{'loading_state': isLoadingState}">
    <div class="modal-header">
        <h4>
            Resources for the operation {{ combinedId }}
        </h4>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="cancel()"
        ></button>
    </div>
    <div class="modal-body">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
            <li [ngbNavItem]="1">
                <button ngbNavLink>Vehicles</button>
                <ng-template ngbNavContent>
                    <div class="vehicles_cover form-container container container-fluid">
                        <app-info-group-body>
                            <!-- selectors section -->
                            <ng-template #noTypesFound>
                                <h6 *ngIf="vehiclesRequestCompleted">No <span *ngIf="vehiclesFetched">more </span>vehicles available</h6>
                                <div *ngIf="!vehiclesRequestCompleted" class="alert alert-light col-12">
                                    <i class="icon fa-solid fa-arrows-rotate loading"></i> Loading...
                                </div>
                            </ng-template>
                            <section class="selectors col-12" *ngIf="types.list.length; else noTypesFound">
                                <ng-container *ngIf="userCan.assignTheVehicles(operation.status)">
                                    <div class="main-content-header">
                                        <h5>Vehicle management</h5>
                                    </div>
                                    <table class="vehicles selectors">
                                        <tr class="form-field">
                                            <td class="col-value col-11">
                                                <div class="flex TJ">
                                                    <div style="width: 30%">
                                                        <select id="types_selector" class="form-select" [(ngModel)]="selectedType.value" (change)="onTypeChange()" [disabled]="!types.list.length">
                                                            <option *ngIf="!types.list.length" [ngValue]="undefined" disabled>... Empty list ...</option>
                                                            <option *ngIf="types.list.length > 1" [ngValue]="undefined" disabled>Select Type</option>
                                                            <option *ngFor="let t of types.list" [value]="t">{{ t }}</option>
                                                        </select>
                                                    </div>
                                                    <div style="width: 30%">
                                                        <select id="capacities_selector" class="form-select" [(ngModel)]="selectedCapacity.value" (change)="onCapacityChange()" [disabled]="!selectedType.value">
                                                            <option *ngIf="!selectedType.value" [ngValue]="undefined" disabled>... Empty list ...</option>
                                                            <option *ngIf="capacities.list.length > 1" [ngValue]="undefined" disabled>Select Capacity</option>
                                                            <option *ngFor="let st of capacities.list" [value]="st">{{ st }}</option>
                                                        </select>
                                                    </div>
                                                    <div style="width: 30%">
                                                        <select id="numbers_selector" class="form-select" [(ngModel)]="selectedNumber.value" [disabled]="!selectedCapacity.value">
                                                            <option *ngIf="!selectedCapacity.value" [ngValue]="undefined" disabled>... Empty list ...</option>
                                                            <option *ngIf="numbers.list.length > 1" [ngValue]="undefined" disabled>Select Number</option>
                                                            <option *ngFor="let n of numbers.list" [value]="n">{{ n }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="col-value col-1" (click)="addVehicle()">
                                                <button
                                                    id="add_vehicle"
                                                    type="button"
                                                    class="btn btn-outline"
                                                    [class]="{'btn-outline-success': selectedNumber.value}"
                                                    [disabled]="!selectedNumber.value"
                                                >
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </ng-container>
                            </section>
                            
                            <!-- selected vehicles section -->
                            <section class="selected_vehicles col-12">
                                <hr class="divider" *ngIf="userCan.assignTheVehicles(operation.status)" />
                                <div class="main-content-header">
                                    <h5 *ngIf="isLoaded(selectedVehicles)">Involved Vehicles</h5>
                                </div>
                                <div class="flex vehicles-container">
                                    <div
                                        *ngFor="let machine of selectedVehicles"
                                        class="flex TL col-4"
                                        [title]="machine?.name"
                                    >
                                        {{ machine?.subType || "" }} {{ machine?.capacityText || "" }} ( {{ machine?.externalId || "- -" }} )
                                        <div style="flex-grow: 1"></div>
                                        <button
                                            *ngIf="userCan.removeTheVehicles(operation.status)"
                                            type="button"
                                            style="align-self: flex-start"
                                            class="btn btn-sm btn-outline-danger"
                                            (click)="removeVehicle(machine)"
                                            >
                                            <fa-icon [icon]="faDelete"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </app-info-group-body>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <button ngbNavLink>Files</button>
                <ng-template ngbNavContent>
                    <div class="files_cover">
                        <section class="files_drop_zone col-12" *ngIf="userCan.attachExtraFiles(operation.status) && !isLoading(operationFiles)">
                            <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropOperationFile($event)">
                            </ngx-file-drop>
                            <hr class="divider" [class]="{'light': !filesRequestCompleted}" />
                        </section>
                        <div *ngIf="!filesRequestCompleted" class="list-group-item loading">
                            <i class="icon fa-solid fa-arrows-rotate loading"></i> Loading...
                        </div>
                        <div *ngIf="filesRequestCompleted && isEmpty(operationFiles)" class="list-group-item">
                            No uploaded files
                        </div>
                        <section class="selected_files col-12 mt-3">
                            <div class="main-content-header">
                                <h5 *ngIf="isLoaded(operationFiles)">Uploaded Files</h5>
                            </div>
                            <div class="flex files-container">
                                <div
                                    *ngFor="let file of operationFiles"
                                    class="col-3 TC"
                                    [title]="file?.name"
                                >
                                    <div class="split-list-group-item-big icon_cover CP">
                                        <ng-template #fileIcon>
                                            <a [href]="file?.content" [download]="file?.name">
                                                <i class="document icon fa-solid fa-file"></i>
                                            </a>
                                        </ng-template>
                                        <div class="previewable">
                                            <img
                                                *ngIf="isImageFile(file.mimeType); else pdfFile"
                                                class="thumb"
                                                [alt]="file.name"
                                                [src]="file.thumbnail || file.url"
                                                (click)="previewIMG(file?.url, file?.name)"
                                            >
                                            <ng-template #pdfFile>
                                                <i
                                                    *ngIf="isPdfFile(file.mimeType); else fileIcon"
                                                    class="pdf icon fa-solid fa-file"
                                                    (click)="previewPDF(file?.url, file?.name)"
                                                ></i>
                                            </ng-template>
                                        </div>
                                    </div>
                                    <div class="file_info flex TC VM m-3">
                                        <div class="filename_cover">{{ file?.name || "- -" }}</div>
                                        <div style="flex-grow: 0.125"></div>
                                        <button *ngIf="userCan.detachExtraFiles(operation.status)"
                                            type="button"
                                            style="align-self: flex-start"
                                            class="btn btn-sm btn-outline-danger"
                                            (click)="removeFile(file.fileId)"
                                            >
                                            <fa-icon [icon]="faDelete"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <dialog id="previewImageModal" closedby="any">
                                <div class="modalContent" [ngClass]="previewClass">
                                    <button class="close-btn" (click)="closeModal()">✕</button>
                                    <div class="zoom-controls">
                                        <button (click)="zoomOut()">−</button>
                                        <button (click)="resetZoom()">Reset</button>
                                        <button (click)="zoomIn()">+</button>
                                    </div>
                                    <div id="preview_instance"
                                         (pointermove)="dragImage($event)"
                                         (pointerup)="stopDrag()"
                                         (pointerleave)="stopDrag()"
                                         (wheel)="onWheel($event)">
                                        <img *ngIf="previewImgSource"
                                             id="modalImage"
                                             [src]="previewImgSource"
                                             draggable="false"
                                             (dragstart)="$event.preventDefault()"
                                             [style.transform]="
                                                'translate(' + translateX + 'px,' +
                                                translateY + 'px) scale(' +
                                                imageZoom + ')'
                                            "
                                             (pointerdown)="startDrag($event)"
                                             alt="">
                                    </div>
                                    <div class="modalInfo" id="modalInfo">{{ modalPreviewFileName }}</div>
                                </div>
                            </dialog>
                        </section>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="3" [disabled]="true">
                <button ngbNavLink>Work instructions</button>
                <ng-template ngbNavContent>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>

    <div class="modal-footer">
        <button *ngIf="operationFiles.length"
                class="btn btn-outline-primary btn-sm"
                (click)="downloadAllFiles()">
            <i class="fa fa-download"></i>
            Download All
        </button>

        <button *ngIf="operation && userCan.manageOperationResources(operation.status)"
                class="btn btn-primary ms-auto"
                ngbAutofocus
                (click)="UpdateOperation()">
            Update Operation resources
        </button>
    </div>
    <i *ngIf="isLoadingState" class="icon fa-solid fa-arrows-rotate loading state"></i>
</div>
